<template>
  <div class="combo-record">
    <div class="header">
      <div class="search-header">
        <el-select v-model="checkClass" placeholder="请选择">
          <el-option
            v-for="item in filterList"
            :key="item.name"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-select v-model="direct_visit" placeholder="请选择">
          <el-option
            v-for="item in directList"
            :key="item.name"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-select v-model="target_building" placeholder="请选择">
          <el-option
            v-for="item in buildData"
            :key="item.building"
            :label="item.building"
            :value="item._id"
          ></el-option>
        </el-select>
        <el-select v-model="target_channels" placeholder="请选择">
          <el-option v-for="item in channelsList" :key="item" :label="item" :value="item"></el-option>
        </el-select>
        <el-date-picker
          v-model="timeVal"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
        <el-input style="margin-left: 5px; width: 300px;" v-model="searchKey" placeholder="请输入手机号">
          <el-button slot="append" icon="el-icon-search" @click="toSearch"></el-button>
        </el-input>
      </div>
      <div class="header-right">
        <a @click="exportTemplate" href="javascript:;" style="cursor: pointer">模板下载</a>
        <el-upload
          class="upload-demo"
          action="customize"
          :http-request="uploadFile"
          :multiple="false"
          :show-file-list="false"
          :before-upload="beforeAvatarUpload"
        >
          <el-button type="primary" :loading="uploadLoading">{{uploadLoading?"上传中":"自访上传"}}</el-button>
        </el-upload>
        <el-button type="primary" :loading="exportIng" @click="exportFile">导出</el-button>
      </div>
    </div>
    <div class="test-table">
      <div class="table-list" ref="tableL">
        <el-table
          v-loading="tableLoading"
          :data="tableData"
          :height="tableHeight"
          style="width: 100%"
        >
          <el-table-column label="序号" type="index" width="100"></el-table-column>
          <el-table-column label="报备时间" width="200" prop="created_at"></el-table-column>
          <el-table-column label="被推荐人姓名" width="150" prop="customer_name"></el-table-column>
          <el-table-column label="被推荐人电话" width="150" prop="customer_phone"></el-table-column>
          <el-table-column label="推荐人姓名" width="150" prop="recommender_name"></el-table-column>
          <el-table-column label="推荐人电话" width="150" prop="recommender_phone"></el-table-column>
          <el-table-column label="预计到访日期" width="200" prop="visit_time"></el-table-column>
          <el-table-column label="渠道" width="150" prop="channel"></el-table-column>
          <el-table-column label="状态" width="100">
            <template slot-scope="scope">
              <span :style="{color: scope.row.tagColor}">{{scope.row.statusName}}</span>
            </template>
          </el-table-column>
          <el-table-column label="实际到访日期" width="200" prop="visit_at"></el-table-column>
          <el-table-column label="置业顾问" width="150" prop="asset_advisor"></el-table-column>
          <el-table-column label="意向楼盘" width="150">
            <template slot-scope="scope">
              <span>{{scope.row.target_building}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="260" fixed="right">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.status === 1 && userRole === 'admin'"
                size="mini"
                type="success"
                @click="changeItem(scope.row)"
              >修改报备</el-button>
              <el-popconfirm
                title="确认再次报备该条记录吗？"
                v-if="scope.row.status === -1"
                @confirm="submitAgain(scope.row)"
              >
                <el-button slot="reference" size="mini" type="primary" style="margin-left: 5px">再次报备</el-button>
              </el-popconfirm>
              <el-button
                v-if="scope.row.status !== -1"
                size="mini"
                type="primary"
                @click="editItem(scope.row)"
              >编辑</el-button>
              <el-popconfirm title="确认删除该条记录吗？" @confirm="delItem(scope.row)">
                <el-button slot="reference" size="mini" type="danger" style="margin-left: 5px">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        class="pagination"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <el-dialog
      title="错误信息"
      width="600px"
      :visible="resultVisible"
      :before-close="()=>{resultVisible = false}"
      :destroy-on-close="true"
    >
      <div class="fail-content">
        <div v-for="(item,index) in resultFail" :key="index" class="fail-item">
          第{{item.line}}条-
          <span>{{item.reason}}</span>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="编辑信息"
      width="600px"
      :visible="visible"
      :before-close="handleClose"
      :destroy-on-close="true"
    >
      <el-form :model="ruleForm" ref="ruleForm" label-width="180px" class="rule-form">
        <el-form-item label="被推荐人姓名：">
          <span>{{ruleForm.customer_name}}</span>
        </el-form-item>
        <el-form-item label="被推荐人电话：">
          <span>{{ruleForm.customer_phone}}</span>
        </el-form-item>
        <el-form-item label="推荐人姓名：">
          <span>{{ruleForm.recommender_name}}</span>
        </el-form-item>
        <el-form-item label="推荐人电话：">
          <span>{{ruleForm.recommender_phone}}</span>
        </el-form-item>
        <el-form-item label="报备时间：">
          <!-- <el-date-picker
            v-model="ruleForm.created_at"
            format="yyyy-MM-dd HH:mm"
            type="datetime"
            placeholder="选择日期时间"
          ></el-date-picker>-->
          <span>{{ruleForm.created_at}}</span>
        </el-form-item>
        <el-form-item label="意向楼盘：" v-if="ruleForm.target_building">
          <span>{{ruleForm.target_building}}</span>
        </el-form-item>
        <el-form-item label="状态：">
          <span :style="{color: ruleForm.tagColor}">{{ruleForm.statusName}}</span>
        </el-form-item>
        <el-form-item label="实际到访日期：">
          <el-date-picker
            v-model="ruleForm.visit_at"
            :disabled="cjEdit"
            format="yyyy-MM-dd HH:mm"
            type="datetime"
            placeholder="选择日期时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="置业顾问：">
          <el-input
            v-model="ruleForm.asset_advisor"
            :disabled="weidaoEdit"
            placeholder="请输入内容"
            style="width: 220px;"
          ></el-input>
        </el-form-item>
        <el-form-item label="有效期剩余：" v-if="ruleForm.protect_days > -1">
          <span>{{ruleForm.protect_days}}天</span>
        </el-form-item>
        <el-form-item label="成交时间：">
          <el-date-picker
            v-model="ruleForm.deal_at"
            :disabled="yidaoEdit"
            format="yyyy-MM-dd HH:mm"
            type="datetime"
            placeholder="选择日期时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input
            v-model="ruleForm.note"
            type="textarea"
            placeholder="请输入内容"
            style="width: 220px;"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" :loading="btnLoading" @click="submitForm('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="修改报备"
      width="600px"
      :visible="visibleB"
      :before-close="handleCloseB"
      :destroy-on-close="true"
    >
      <el-form :model="ruleFormB" ref="ruleFormB" label-width="180px" class="rule-form">
        <el-form-item label="被推荐人姓名：">
          <span>{{ruleFormB.customer_name}}</span>
        </el-form-item>
        <el-form-item label="被推荐人电话：">
          <span>{{ruleFormB.customer_phone}}</span>
        </el-form-item>
        <el-form-item label="推荐人姓名：">
          <span>{{ruleFormB.recommender_name}}</span>
        </el-form-item>
        <el-form-item label="推荐人电话：">
          <span>{{ruleFormB.recommender_phone}}</span>
        </el-form-item>
        <el-form-item label="报备时间：">
          <el-date-picker
            v-model="ruleFormB.created_at"
            format="yyyy-MM-dd HH:mm"
            type="datetime"
            placeholder="选择日期时间"
          ></el-date-picker>
          <!-- <span>{{ruleFormB.created_at}}</span> -->
        </el-form-item>
        <el-form-item label="意向楼盘：" v-if="ruleFormB.target_building">
          <span>{{ruleFormB.target_building}}</span>
        </el-form-item>
        <el-form-item label="状态：">
          <span style="color: #3679ff">已到访</span>
        </el-form-item>
        <el-form-item label="实际到访日期：">
          <el-date-picker
            v-model="ruleFormB.visit_at"
            format="yyyy-MM-dd HH:mm"
            type="datetime"
            placeholder="选择日期时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="置业顾问：">
          <el-input
            v-model="ruleFormB.asset_advisor"
            :disabled="true"
            placeholder="请输入内容"
            style="width: 220px;"
          ></el-input>
        </el-form-item>
        <el-form-item label="有效期剩余：" v-if="ruleFormB.protect_days > -1">
          <span>{{ruleFormB.protect_days}}天</span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseB">取 消</el-button>
        <el-button type="primary" :loading="btnLoadingB" @click="submitFormB('ruleFormB')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Api from "@/api/api";
import { mapGetters } from "vuex";
const moment = require("moment");
export default {
  data() {
    return {
      exportIng: false,
      checkClass: "",
      tableHeight: 0,
      tableLoading: false,
      uploadLoading: false,
      resultVisible: false,
      resultFail: [],
      btnLoading: false,
      btnLoadingB: false,
      visible: false,
      visibleB: false,
      searchKey: "",
      currentPage: 1,
      pageSize: 10,
      total: 0,
      direct_visit: "0",
      timeVal: "",
      buildData: [],
      channelsList: [],
      target_building: "",
      target_channels: "",
      directList: [
        { id: "0", name: "非线下直访" },
        { id: "1", name: "线下直访" }
      ],
      filterList: [
        { id: "", name: "全部", color: "#3679ff" },
        { id: 0, name: "未到访", color: "#fd9222" },
        { id: 1, name: "已到访", color: "#3679ff" },
        { id: 2, name: "已成交", color: "#62c66b" },
        { id: -1, name: "已过期", color: "#f56c6c" }
      ],
      paramsData: {
        direct_visit: "0",
        customer_phone: "",
        start_time: "",
        end_time: "",
        target_building: "",
        page: 1,
        page_size: 10
      },
      tableData: [
        {
          user: "推荐人",
          phone: "1233454353",
          ruser: "李四",
          rphone: "3435345"
        }
      ],
      ruleForm: {},
      ruleFormB: {}
    };
  },
  computed: {
    ...mapGetters(["userRole"]),
    weidaoEdit() {
      return this.ruleForm.status !== 0;
    },
    yidaoEdit() {
      return this.ruleForm.status !== 1;
    },
    cjEdit() {
      return this.ruleForm.status === 2;
    }
  },
  async mounted() {
    await this.getBUilding();
    await this.getChannelsList();
    await this.getList(this.paramsData);
    setTimeout(() => {
      this.tableHeight = this.$refs.tableL.offsetHeight;
      console.log(this.tableHeight)
    }, 500);
  },
  methods: {
    async getBUilding() {
      const { data } = await Api.buildList();
      const { userInfo } = this.$store.state;
      if (userInfo.role === "agency") {
        const newBuilds = [];
        userInfo.target_buildings.forEach(vl => {
          const newVal = data.find(item => item._id === vl);
          newBuilds.push(newVal);
        });
        this.buildData = newBuilds;
      } else {
        this.buildData = data;
      }
      this.target_building = this.buildData[0]._id;
      this.paramsData.target_building = this.buildData[0]._id;
    },
    async getChannelsList() {
      const { data } = await Api.channelsList();
      const { userInfo } = this.$store.state;
      if (userInfo.role === "agency") {
        this.channelsList = ["全部渠道", ...userInfo.target_channels];
      } else {
        this.channelsList = ["全部渠道", ...data];
      }
      this.target_channels = this.channelsList[0];
    },
    exportFile() {
      const paramsData = {
        customer_phone: this.searchKey,
        direct_visit: this.direct_visit,
        target_building: this.target_building
      };
      if (this.checkClass !== "") {
        paramsData.status = this.checkClass;
      }
      if (this.searchKey) {
        paramsData.customer_phone = this.searchKey;
      }
      if (this.timeVal && this.timeVal.length > 0) {
        paramsData.start_time =
          moment(this.timeVal[0]).format("YYYY-MM-DD") + " 00:00:00";
        paramsData.end_time =
          moment(this.timeVal[1]).format("YYYY-MM-DD") + " 23:59:59";
      } else {
        paramsData.start_time = "";
        paramsData.end_time = "";
      }
      if (
        this.target_channels &&
        this.target_channels !== this.channelsList[0]
      ) {
        paramsData.channel = this.target_channels;
      }
      paramsData.direct_visit = this.direct_visit;
      this.exportIng = true;
      Api.exportFile(paramsData).then(() => {
        this.exportIng = false;
      });
    },
    exportTemplate() {
      const paramsData = {
        template: 1
      };
      Api.exportFile(paramsData);
    },
    async getList(params = this.paramsData) {
      this.tableLoading = true;
      params.role = "agency";
      try {
        const res = await Api.getCommondList(params);
        if (res.page_data.length > 0) {
          const dataArr = res.page_data.map(vl => {
            const filterData = this.filterList.find(
              item => item.id === vl.status
          );
          return {
            ...vl,
            statusName: filterData ? filterData?.name : "",
            tagColor: filterData ? filterData?.color : ""
          };
        });
        this.tableData = dataArr;
      } else {
        this.tableData = [];
      }
      this.total = res.total;
      this.tableLoading = false;
      } catch (error) {
        this.tableLoading = false;
        this.tableData = [];
      }
    },
    toSearch() {
      this.currentPage = 1;
      this.paramsData = {
        customer_phone: this.searchKey,
        page: this.currentPage,
        page_size: this.pageSize,
        direct_visit: this.direct_visit,
        target_building: this.target_building
      };
      if (
        this.target_channels &&
        this.target_channels !== this.channelsList[0]
      ) {
        this.paramsData.channel = this.target_channels;
      }
      if (this.checkClass !== "") {
        this.paramsData.status = this.checkClass;
      }
      if (this.timeVal && this.timeVal.length > 0) {
        this.paramsData.start_time =
          moment(this.timeVal[0]).format("YYYY-MM-DD") + " 00:00:00";
        this.paramsData.end_time =
          moment(this.timeVal[1]).format("YYYY-MM-DD") + " 23:59:59";
      } else {
        this.paramsData.start_time = "";
        this.paramsData.end_time = "";
      }
      this.getList(this.paramsData);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.paramsData.page = val;
      this.getList(this.paramsData);
    },
    beforeAvatarUpload(file) {
      const reg = /^.*\.(?:xls|xlsx)$/i; //文件名可以带空格
      const isEXCEL = reg.test(file.name);
      if (!isEXCEL) {
        this.$message.error("请上传excel格式的文件!");
      }
      return isEXCEL;
    },
    async uploadFile(params) {
      const _file = params.file;
      var formData = new FormData();
      formData.append("file", _file);
      this.uploadLoading = true;
      this.resultFail = [];
      const res = await Api.importRequest(formData);
      if (res && res.fail.length > 0) {
        this.resultFail = res.fail;
        this.resultVisible = true;
      } else {
        this.$message({
          message: "上传成功",
          type: "success"
        });
      }
      this.uploadLoading = false;
      this.getList(this.paramsData);
    },
    handleClose() {
      this.visible = false;
      this.btnLoading = false;
    },
    handleCloseB() {
      this.visibleB = false;
      this.btnLoadingB = false;
    },
    delItem(item) {
      Api.delItem({
        delete_record_id: item._id
      }).then(res => {
        if (res.code === 200) {
          this.$message({
            message: "删除成功",
            type: "success"
          });
          this.getList(this.paramsData);
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    },
    submitForm() {
      console.log("ok");
      if (!this.ruleForm.asset_advisor) {
        this.$message({
          message: "置业顾问不能为空",
          type: "warning"
        });
        return;
      }
      let params = {};
      if (this.ruleForm.status === 0) {
        if (!this.ruleForm.created_at) {
          this.$message({
            message: "请先填写报备时间",
            type: "warning"
          });
          return;
        }
        if (!this.ruleForm.visit_at) {
          this.$message({
            message: "请先填写实际到访时间",
            type: "warning"
          });
          return;
        }
        if (!this.ruleForm.asset_advisor) {
          this.$message({
            message: "请先填写置业顾问",
            type: "warning"
          });
          return;
        }
        params = {
          status: 1,
          visit_at: moment(this.ruleForm.visit_at).format("YYYY-MM-DD HH:mm"),
          created_at: moment(this.ruleForm.created_at).format(
            "YYYY-MM-DD HH:mm"
          ),
          note: this.ruleForm.note,
          asset_advisor: this.ruleForm.asset_advisor
        };
      }
      if (this.ruleForm.status === 1) {
        if (!this.ruleForm.created_at) {
          this.$message({
            message: "请先填写报备时间",
            type: "warning"
          });
          return;
        }
        if (!this.ruleForm.deal_at) {
          this.$message({
            message: "请先填写成交时间",
            type: "warning"
          });
          return;
        }
        if (!this.ruleForm.visit_at) {
          this.$message({
            message: "请先填写实际到访时间",
            type: "warning"
          });
          return;
        }
        params = {
          status: 2,
          deal_at: moment(this.ruleForm.deal_at).format("YYYY-MM-DD HH:mm"),
          visit_at: moment(this.ruleForm.visit_at).format("YYYY-MM-DD HH:mm"),
          created_at: moment(this.ruleForm.created_at).format(
            "YYYY-MM-DD HH:mm"
          ),
          note: this.ruleForm.note
        };
      }
      if (this.ruleForm.status === 2) {
        params = {
          note: this.ruleForm.note,
          created_at: moment(this.ruleForm.created_at).format(
            "YYYY-MM-DD HH:mm"
          )
        };
      }
      console.log(params);
      this.btnLoading = true;
      params.modify_record_id = this.ruleForm._id;
      Api.submitAudit(params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: "保存成功",
            type: "success"
          });
          this.visible = false;
          this.getList(this.paramsData);
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
        this.btnLoading = false;
      });
    },
    submitFormB() {
      if (!this.ruleFormB.created_at) {
        this.$message({
          message: "请先填写报备时间",
          type: "warning"
        });
        return;
      }
      if (!this.ruleFormB.visit_at) {
        this.$message({
          message: "请先填写实际到访时间",
          type: "warning"
        });
        return;
      }
      let params = {
        created_at: moment(this.ruleFormB.created_at).format(
          "YYYY-MM-DD HH:mm"
        ),
        visit_at: moment(this.ruleFormB.visit_at).format("YYYY-MM-DD HH:mm"),
        info: ""
      };
      params.modify_record_id = this.ruleFormB._id;
      this.btnLoadingB = true;
      Api.changeItem(params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: "保存成功",
            type: "success"
          });
          this.visibleB = false;
          this.getList(this.paramsData);
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
        this.btnLoadingB = false;
      });
    },
    editItem(item) {
      this.ruleForm = JSON.parse(JSON.stringify(item));
      this.visible = true;
    },
    submitAgain(item) {
      console.log(item);
      if (!item.is_renew) {
        this.$message({
          message: item.renew_msg,
          type: "warning"
        });
        return;
      }
      Api.submitAgain({
        record_id: item._id
      }).then(res => {
        console.log(res);
        if (res.code === 200) {
          this.$message({
            message: "再次报备成功",
            type: "success"
          });
          this.getList(this.paramsData);
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    },
    changeItem(item) {
      this.ruleFormB = JSON.parse(JSON.stringify(item));
      this.visibleB = true;
    }
  }
};
</script>
<style lang="scss" scoped>
.combo-record {
  position: relative;
  width: 100%;
  height: 100%;
  color: #333333;
  .fail-content {
    padding: 0 30px;
    .fail-item {
      line-height: 36px;
      span {
        color: #f56c6c;
      }
    }
  }
  .header {
    .title {
      width: 150px;
      font-size: 1.2rem;
    }
    display: flex;
    height: 40px;
    line-height: 40px;
    justify-content: space-between;
    .el-select {
      width: 160px;
    }
  }
  .search-header {
    display: flex;
  }
  .header-right {
    display: flex;
    width: 300px;
    a {
      color: #2196f3;
    }
    .upload-demo {
      margin: 0 10px;
    }
  }
  .test-table {
    width: 100%;
    height: calc(100% - 80px);
    margin-top: 20px;
    background: #ffffff;
    position: relative;
    border-radius: 6px;
    overflow: hidden;
  }
  .table-list {
    width: 100%;
    height: calc(100% - 40px);
    img {
      background: #dcdfe6;
      width: 50px;
      height: 50px;
      border-radius: 50%;
    }
    .table-expand {
      font-size: 0;
      padding: 0 100px;
    }
    .table-expand label {
      width: 90px;
      color: #99a9bf;
    }
    .table-expand .el-form-item {
      margin-right: 0;
      margin-bottom: 0;
      width: 100%;
    }
  }
  .pagination {
    display: flex;
    justify-content: flex-end;
  }
  .user-info-item {
    display: flex;
    // cursor: pointer;
    // &:hover {
    //   color: rgb(96, 200, 224);
    // }
  }
}
</style>
